import './MiniCard.scss'

export default function MiniCard({title, text, img}){

    return(
        <div className="MiniCard">
            <div className="container">
                <img src={img} alt="icon" />
                <div className="content">
                    <h2>{title}</h2>
                    <p>{text}</p>
                </div>
            </div>
        </div>
    )
}